import React, { useCallback, useContext, useState, useEffect } from 'react';
import styles from '../BuildPlan.module.css';
import cn from 'classnames';
import { ReactComponent as Washer } from '../../../assets/images/washer.svg';
import { ReactComponent as Electric } from '../../../assets/images/electrical.svg';
import { ReactComponent as Plumbing } from '../../../assets/images/plumbing.svg';
import { ReactComponent as Utilities } from '../../../assets/images/external-water.svg';
import { ReactComponent as HVAC } from '../../../assets/images/hvac.svg';
import { BuildPlanContext } from '../../contexts/DTC/DTCContext';
import { standardCategories } from '../DummyData';
import SelectionCard from '../SelectionCard';

const CategorySelect = ({ allCategories, onChange }) => {
    const { state, dispatch } = useContext(BuildPlanContext);
    const lists = {
        sel: state.selectedCategoryIds,
        unsel: state.unselectedCategoryIds
    };

    useEffect(() => {
        const fetchAvailableCategoriesByClient = /*ASYNC*/ () => {
            /**
             * DO API STUFF
             *   .then(res) => {
             *     dispatch({ type: "INIT", payload:{
             *       availableCategories: res,
             *       unselectedCategoryIds: res.filter( cat => !state.selectedCategoryIds.includes(cat.id)).map( c => c.id)
             *     }})
             *   }
             */
            return;
        };
        fetchAvailableCategoriesByClient();

        // ======= remove this dispatch after call is wired up =======
        dispatch({
            type: 'INIT',
            payload: {
                availableCategories: standardCategories,
                unselectedCategoryIds: standardCategories
                    .filter((cat) => !state.selectedCategoryIds.includes(cat.id))
                    .map((c) => c.id)
            }
        });
        // ==========================================================
    }, []);

    const handleSelectAcion = (cat, action) => {
        dispatch({
            type: 'SELECT_CATEGORIES',
            payload: {
                categoryId: cat,
                action: action
            }
        });
    };

    if (state.selectedCategoryIds?.length === 0 && lists.unsel?.length === 0) return null;

    return (
        <>
            <h3 className='h4'>What type of protection are you interested in?</h3>
            <p>Select all that apply and click Continue.</p>
            <div className={styles.flex}>
                {lists.sel.map((c, i) => (
                    <CategoryCard
                        categoryId={c}
                        onClick={() => handleSelectAcion(c, 'remove')}
                        checked
                    />
                ))}
                {lists.sel.length > 0 && lists.unsel.length > 0 && <div className={styles.divider} />}
                {lists.unsel.map((c, i) => (
                    <CategoryCard
                        categoryId={c}
                        onClick={() => handleSelectAcion(c, 'add')}
                    />
                ))}
            </div>
        </>
    );
};

const CategoryCard = ({ categoryId, checked = false, onClick }) => {
    const { availableCategories } = useContext(BuildPlanContext)?.state;

    const categoryContent = useCallback(() => {
        // console.log("=== availableCategories, categoryId ===", availableCategories, categoryId)
        const title = availableCategories?.find((c) => categoryId === c.id)?.name || categoryId;
        switch (categoryId) {
            case 'appliances':
                return { title, icon: <Washer className={styles.categoryIcon} /> };
            case 'utilities':
                return { title, icon: <Utilities className={styles.categoryIcon} /> };
            case 'plumbing':
                return { title, icon: <Plumbing className={styles.categoryIcon} /> };
            case 'hvac':
                return { title, icon: <HVAC className={styles.categoryIcon} /> };
            case 'electrical':
                return { title, icon: <Electric className={styles.categoryIcon} /> };
            default: {
                console.warn('Developer Error: Invalid category');
                return { title, icon: null };
            }
        }
    }, [categoryId]);

    const { icon, title } = categoryContent();
    return (
        <SelectionCard
            onClick={onClick}
            title={title}
            icon={icon}
            type='checkbox'
            checked={checked}
        />
    );
};

export default CategorySelect;
